/*
  Ответ реестра банкротств по одному должнику счёта (21.10.2026).

  Показывается ВСЁ найденное, а не «лучшее совпадение»: тот ли это человек,
  реестр не решает, и мы тоже. Первыми стоят карточки без расхождений с тем, что
  мы спросили; остальные - однофамильцы и неточные совпадения - свёрнуты (по
  частому имени реестр отдаёт десятки карточек, а нужная не должна утонуть).

  Вид «не найден» бывает трёх видов, и их нельзя сливать: ответ настоящего
  реестра, ответ тестового (он не значит «не банкрот») и «не проверен», когда о
  человеке ничего не известно. Слова приходят с сервера (`headline`); здесь
  только цвет метки.

  Сама карточка, сведения о процедуре по ней и запрос сообщений по номеру - в
  `RegistryCard.jsx` (23.10.2026); подписи дат - в `registryLines.js`.
*/

import { useState } from 'react'

import { Tag } from './Common.jsx'
import RegistryCard from './RegistryCard.jsx'

/* Короткая метка по виду ответа; полная фраза приходит с сервера и стоит под ней
   обычной строкой: в метке она не переносится и растягивала страницу на телефоне. */
const TAGS = {
  found: ['warn', 'найдено'],
  not_found: ['calm', 'не найден'],
  not_checked: ['burn', 'не проверен'],
  pending: ['muted', 'проверяется'],
  skipped: ['muted', 'пропущен'],
}

/* «Не найден» тестового реестра - не «в норме»: зелёная метка читается быстрее
   фразы под ней и говорила бы «не банкрот» (21.10.2026, ревью). */
const TEST_NOT_FOUND = ['warn', 'тестовый реестр']

function tagOf(outcome, isTest) {
  if (outcome === 'not_found' && isTest) return TEST_NOT_FOUND
  return TAGS[outcome] ?? TAGS.pending
}

export default function RegistryPersonResult({ result, isTest, ask }) {
  const [all, setAll] = useState(false)
  const exact = result.debtors.filter((card) => card.differs_on.length === 0)
  const others = result.debtors.filter((card) => card.differs_on.length > 0)
  const shown = all ? others : []
  const [tagKind, tagText] = tagOf(result.outcome, isTest)

  return (
    <div className="registry-person">
      <div>
        <strong>{result.full_name}</strong> <Tag kind={tagKind}>{tagText}</Tag>
      </div>
      <div>{result.headline}</div>
      {result.failure_reason ? <div className="muted">Причина: {result.failure_reason}</div> : null}
      {exact.length ? (
        <ul className="registry-cards">
          {exact.map((card) => (
            <RegistryCard key={card.guid} card={card} ask={ask} />
          ))}
        </ul>
      ) : null}
      {others.length ? (
        <>
          <button
            type="button"
            className="link-button"
            aria-expanded={all}
            onClick={() => setAll(!all)}
          >
            {all ? 'Скрыть' : 'Показать'} карточки с расхождениями: {others.length}
          </button>
          <ul className="registry-cards">
            {shown.map((card) => (
              <RegistryCard key={card.guid} card={card} ask={ask} />
            ))}
          </ul>
        </>
      ) : null}
    </div>
  )
}
